export default function AdminLoading({
  text = "Loading...",
}) {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-green-500" />
      <p className="text-gray-400 mt-4">
        {text}
      </p>
    </div>
  );
}